module.exports = __webpack_public_path__ + "img/paymentFailed.b449965e.png";